import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import { CategoryFilterValue } from '@features/spa/hooks/useSpaEntityFilter';
import { SpaTreatmentsConnected as SpaTreatmentsV1 } from './container';
import { SpaTreatmentsV2 } from './v2';

type SpaTreatmentsVersionProps = {
  categoryId?: CategoryFilterValue;
  language: string;
  isLoading?: boolean;
};

export const SpaTreatmentsVersion: FC<SpaTreatmentsVersionProps> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2) return <SpaTreatmentsV2 {...props} />;
  return <SpaTreatmentsV1 {...props} />;
};
